// @flow
import { createAction } from 'redux-actions';
import * as types from '../constants/App';
import { getErrorProps } from '../utilities/error';

export const appInitial = createAction(types.APP_INITIAL);

// Actions
export const appLoading = createAction(types.APP_LOADING);
export const appLoadingAction = payload => dispatch => (
  dispatch(appLoading(payload))
);

export const appModalActivator = createAction(types.APP_MODAL_ACTIVATOR);
export const appModalActivatorAction = payload => dispatch => (
  dispatch(appModalActivator(payload))
);

export const appError = createAction(types.APP_ERROR);
export const isCompactWidget = () => {
  const wrapperTag = import.meta.env.VITE_WRAPPER_TAG;
  return document.querySelector(wrapperTag).shadowRoot ?
    !!document.querySelector(wrapperTag).shadowRoot.querySelector('.widget-compact') :
    !!document.querySelector('.widget-compact');
};
export const appErrorAction = payload => (dispatch, getState) => {
  const state = getState();
  const {
    app: {
      error,
      debugServices,
      debugErrors,
    },
    section: {
      currentSectionId, currentPageData: {
        currentPageId, currentStepData: { currentStepId },
      }, packageData: { errors },
    },
    userData: {
      isCalculatingPrice,
      isPurchase,
    },
  } = state;
  // Don't allow the next error to override our existing error flow.
  if (!error) {
    // New model where we get the errors props.
    if (isCompactWidget()) {
      dispatch(appModalActivatorAction({ active: false }));
    }
    const errorProps =
      getErrorProps(payload, errors, debugServices, debugErrors, isCalculatingPrice, isPurchase);
    return dispatch(appError({
      ...payload,
      currentSectionId,
      currentPageId,
      currentStepId,
      hasOriginal: false,
      steps: errorProps,
    }));
  }
  return {};
};

export const appUpdateState = createAction(types.APP_UPDATE_STATE);
export const appUpdateStateAction = payload => dispatch => (
  dispatch(appUpdateState(payload))
);
